export const REGISTRATION_SUCCESS = 'Registration successful! You can now log in.';
export const LOGIN_SUCCESS = 'Login successful!';
export const ORG_SUCCESS = 'Organization creation successful!';
export const FORGOT_PASSWORD_SUCCESS = 'Link sent successfully'